import {DEFAULT_MARKER} from "../../utils/google/maps.js";

const matchesQuery = (element, query) =>
  !query || element?.label?.toLowerCase().includes(query.toLowerCase());

const resolvedMarkerId = (element, markerKeys) => {
  const markerId = element?.markerId;
  if (markerId != null && markerId !== "" && markerKeys.has(String(markerId)))
    return String(markerId);
  return DEFAULT_MARKER.id;
};

/**
 * Groups stay when the group itself matches the search and marker filter.
 * A missing or unknown markerId counts as Uncategorized.
 * The builder page can keep a parent whose own label missed the search when a child matched.
 */
const filterFacilityBuilder = (
  builder,
  {query = "", activeFilters = [], markerIconMap = {}, keepParentsOfMatches = false} = {}
) => {
  if (!builder?.allIds || !builder?.byId) return null;
  if (activeFilters.length === 0 && !query) return null;

  const {allIds, byId} = builder;
  const markerKeys = new Set(Object.keys(markerIconMap).map(String));
  const selected = new Set(activeFilters.map(String));
  const matchesMarker = name =>
    selected.size === 0 || selected.has(resolvedMarkerId(byId[name], markerKeys));

  const updatedAllIds = allIds.filter(
    name => matchesQuery(byId[name], query) && matchesMarker(name)
  );

  const groups = Object.entries(byId).filter(
    ([name, element]) => matchesQuery(element, query) && allIds.includes(name)
  );
  const components = Object.entries(byId).filter(
    ([name, element]) => matchesQuery(element, query) && !allIds.includes(name)
  );
  const updatedById = Object.fromEntries([...groups, ...components]);

  if (keepParentsOfMatches)
    components
      .filter(([, element]) => element.parentName)
      .forEach(([, element]) => {
        const {parentName} = element;
        if (!(parentName in updatedById) && byId[parentName]) {
          updatedById[parentName] = byId[parentName];
          if (!updatedAllIds.includes(parentName)) updatedAllIds.push(parentName);
        }
      });

  updatedAllIds.sort((a, b) => allIds.indexOf(a) - allIds.indexOf(b));

  return {allIds: updatedAllIds, byId: updatedById};
};

export default filterFacilityBuilder;
